'use client';

import React, { useEffect, useRef, useState } from 'react';
import Link from 'next/link';
import { Building2, Phone, ShieldCheck, ClipboardList, HeartPulse, Users, FileText } from 'lucide-react';



interface CorporateClient {
  name: string;
  logo: string;
  alt: string;
}

const corporateClients: CorporateClient[] = [
  {
    name: 'Maruti Suzuki',
    logo: '/assets/images/7-1784959981362.png',
    alt: 'Maruti Suzuki logo - Indian automobile manufacturer',
  },
  {
    name: 'NSDC',
    logo: '/assets/images/8-1784959981539.png',
    alt: 'NSDC logo - National Skill Development Corporation',
  },
  {
    name: 'NSN',
    logo: '/assets/images/9-1784959981535.png',
    alt: 'NSN logo - corporate client',
  },
  {
    name: 'Adani',
    logo: '/assets/images/10-1784959981531.png',
    alt: 'Adani logo - Indian multinational conglomerate',
  },
  {
    name: 'Qikwell',
    logo: '/assets/images/11-1784959981661.png',
    alt: 'Qikwell logo - healthcare appointment platform',
  },
  {
    name: 'Motherson Sumi Systems',
    logo: '/assets/images/16-1784959707344.png',
    alt: 'Motherson Sumi Systems logo - global automotive components manufacturer',
  },
  {
    name: 'Reliance',
    logo: '/assets/images/15-1784959707334.png',
    alt: 'Reliance logo - Indian multinational conglomerate',
  },
  {
    name: 'JSW',
    logo: '/assets/images/14-1784959707193.png',
    alt: 'JSW logo - Indian multinational steel and energy company',
  },
  {
    name: 'Avyukt Healthcare Solutions',
    logo: '/assets/images/13-1784959708290.png',
    alt: 'Avyukt Healthcare Solutions logo - healthcare services company',
  },
  {
    name: 'Optum',
    logo: '/assets/images/12-1784959708288.png',
    alt: 'Optum logo - health services and innovation company',
  },
  {
    name: 'Client 21',
    logo: '/assets/images/21-1784959593197.png',
    alt: 'Corporate client logo 21',
  },
  {
    name: 'Client 20',
    logo: '/assets/images/20-1784959593203.png',
    alt: 'Corporate client logo 20',
  },
  {
    name: 'Client 19',
    logo: '/assets/images/19-1784959592916.png',
    alt: 'Corporate client logo 19',
  },
  {
    name: 'Client 18',
    logo: '/assets/images/18-1784959593400.png',
    alt: 'Corporate client logo 18',
  },
  {
    name: 'Client 17',
    logo: '/assets/images/17-1784959593201.png',
    alt: 'Corporate client logo 17',
  },
  {
    name: 'Bio-Rad',
    logo: '/assets/images/images__13_-1784958787133.png',
    alt: 'Bio-Rad logo - life science research and clinical diagnostics company',
  },
  {
    name: 'MG Motor',
    logo: '/assets/images/580b57fcd9996e24bc43c498-1784958787227.png',
    alt: 'MG Motor logo - British automotive brand',
  },
  {
    name: 'BD',
    logo: '/assets/images/bd-logo-png-transparent-1784958787240.png',
    alt: 'BD (Becton Dickinson) logo - global medical technology company',
  },
  {
    name: 'Taco Bell',
    logo: '/assets/images/Taco_Bell-Logo.wine-1784958787137.png',
    alt: 'Taco Bell logo - American fast food chain',
  },
  {
    name: 'GE',
    logo: '/assets/images/bac35e613add764a9ef762a4ee4973f3-1784958641879.webp',
    alt: 'GE logo - General Electric multinational conglomerate',
  },
  {
    name: 'Dell',
    logo: '/assets/images/Dell-Logo-1784958643119.png',
    alt: 'Dell logo - American multinational technology company',
  },
  {
    name: 'Polycab',
    logo: '/assets/images/download__5_-1784958641935.png',
    alt: 'Polycab logo - Indian electrical goods manufacturer',
  },
  {
    name: 'Britannia',
    logo: '/assets/images/Britannia_Industries_logo_with_motto.svg-1784958642023.png',
    alt: 'Britannia Industries logo - Indian food products corporation',
  },
  {
    name: 'Symbiosis',
    logo: '/assets/images/png-transparent-symbiosis-law-school-symbiosis-international-deemed-university-symbiosis-school-of-economics-symbiosis-college-of-arts-and-commerce-symbiosis-society-hyderabad-miscellaneous-text-logo-1784958641938.png',
    alt: 'Symbiosis International University logo - deemed university',
  },
  {
    name: 'Samsung Display',
    logo: '/assets/images/smasung-display_1-1784957805229.jpg',
    alt: 'Samsung Display logo - display panel manufacturer',
  },
  {
    name: 'Rekhta Foundation',
    logo: '/assets/images/Rekhta-foundation-1784957805058.png',
    alt: 'Rekhta Foundation logo - Urdu language and literature organization',
  },
  {
    name: 'Accenture',
    logo: '/assets/images/png-clipart-accenture-new-logo-icons-logos-emojis-iconic-brands-thumbnail-1784957805057.png',
    alt: 'Accenture logo - global professional services company',
  },
  {
    name: 'Saraswat Bank',
    logo: '/assets/images/sarawast-bank-logo-04-1784957805161.png',
    alt: 'Saraswat Bank logo - Indian cooperative bank',
  },
  {
    name: 'Ansell',
    logo: '/assets/images/Ansell-1784957805056.png',
    alt: 'Ansell logo - global leader in protection solutions',
  },
  {
    name: 'Mercedes-Benz',
    logo: '/assets/images/Mercedes-Logo.svg-1784957068724.png',
    alt: 'Mercedes-Benz logo - German luxury automobile manufacturer',
  },
  {
    name: 'Sodexo',
    logo: '/assets/images/5848244acef1014c0b5e49ca-1784957068618.png',
    alt: 'Sodexo logo - food services and facilities management company',
  },
  {
    name: 'Vestas',
    logo: '/assets/images/019dfa3044cc4658e13375c66bf5fd31-1784957068232.jpg',
    alt: 'Vestas logo - wind turbine manufacturer',
  },
  {
    name: 'Toyota',
    logo: '/assets/images/emblem_001-1784957068456.jpg',
    alt: 'Toyota logo - Japanese multinational automobile manufacturer',
  },
  {
    name: 'Emaar',
    logo: '/assets/images/Emaar-mgf-customer-care-new-delhi-delhi-construction-companies-19ltvn7-1784957068308.webp',
    alt: 'Emaar MGF logo - real estate development company',
  },
];

const services = [
  { icon: ClipboardList, label: 'Pre-Employment\nCheck-ups' },
  { icon: HeartPulse, label: 'Annual Health\nCheck-ups' },
  { icon: Building2, label: 'On-site Medical\nCamps' },
  { icon: Users, label: 'Employee Health\nScreening' },
  { icon: FileText, label: 'Digital Reports &\nDedicated Support' },
];

function LogoCard({ client }: { client: CorporateClient }) {
  const [imgError, setImgError] = useState(false);

  return (
    <div
      className="flex flex-col items-center justify-center bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300 cursor-default"
      style={{ minHeight: '160px', padding: '30px 36px' }}
    >
      {!imgError ? (
        <img
          src={client.logo}
          alt={client.alt}
          className="w-auto max-w-full object-contain"
          style={{ minHeight: '100px', maxHeight: '110px' }}
          onError={() => setImgError(true)}
          loading="lazy"
        />
      ) : (
        <div
          className="flex items-center justify-center rounded-xl font-extrabold text-lg tracking-tight bg-blue-50 text-blue-700"
          style={{ minHeight: '100px', width: '100%' }}
        >
          {client.name.slice(0, 3).toUpperCase()}
        </div>
      )}
    </div>
  );
}

interface CorporateClientsSectionProps {
  variant?: 'homepage' | 'full';
  showCarousel?: boolean;
}

export default function CorporateClientsSection({
  variant = 'homepage',
  showCarousel = true,
}: CorporateClientsSectionProps) {
  const carouselRef = useRef<HTMLDivElement>(null);
  const [isPaused, setIsPaused] = useState(false);
  const animFrameRef = useRef<number | null>(null);
  const posRef = useRef(0);

  useEffect(() => {
    if (!showCarousel) return;
    const el = carouselRef.current;
    if (!el) return;
    const speed = 0.5;
    const animate = () => {
      if (!isPaused && el) {
        posRef.current += speed;
        const halfWidth = el.scrollWidth / 2;
        if (posRef.current >= halfWidth) posRef.current = 0;
        el.style.transform = `translateX(-${posRef.current}px)`;
      }
      animFrameRef.current = requestAnimationFrame(animate);
    };
    animFrameRef.current = requestAnimationFrame(animate);
    return () => {
      if (animFrameRef.current) cancelAnimationFrame(animFrameRef.current);
    };
  }, [isPaused, showCarousel]);

  const duplicatedClients = [...corporateClients, ...corporateClients];

  return (
    <section className="py-20 bg-white relative overflow-hidden" id="corporate-clients">
      {/* Subtle watermark */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none opacity-[0.025]">
        <span className="text-[18vw] font-extrabold text-[#0c2d6b] whitespace-nowrap tracking-widest">
          51 PLUS LAB
        </span>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#0c2d6b] mb-3 leading-tight">
            Our Corporate Clients
          </h2>
          {/* Decorative divider with handshake icon */}
          <div className="flex items-center justify-center gap-3 mb-5">
            <div className="h-px w-16 bg-blue-300" />
            <span className="text-blue-400 text-xl">🤝</span>
            <div className="h-px w-16 bg-blue-300" />
          </div>
          <p className="text-gray-600 max-w-2xl mx-auto text-base leading-relaxed">
            51 Plus Lab is trusted by leading organizations for Pre-Employment Medical Check-ups,
            Annual Health Check-ups, Corporate Medical Camps and Diagnostic Services.
          </p>
        </div>

        {/* Auto-scrolling Carousel */}
        {showCarousel && (
          <div
            className="overflow-hidden mb-12 relative"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
            onTouchStart={() => setIsPaused(true)}
            onTouchEnd={() => setIsPaused(false)}
          >
            <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
            <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />
            <div
              ref={carouselRef}
              className="flex gap-4 will-change-transform"
              style={{ width: 'max-content' }}
            >
              {duplicatedClients.map((client, idx) => (
                <div key={`carousel-${client.name}-${idx}`} className="w-44 flex-shrink-0">
                  <div
                    className="flex items-center justify-center bg-white rounded-xl border border-gray-200 shadow-sm"
                    style={{ height: '100px', padding: '12px 16px' }}
                  >
                    <img
                      src={client.logo}
                      alt={client.alt}
                      className="w-auto max-w-full object-contain"
                      style={{ maxHeight: '70px' }}
                      loading="lazy"
                      onError={(e) => {
                        const target = e.currentTarget as HTMLImageElement;
                        target.style.display = 'none';
                        const parent = target.parentElement;
                        if (parent) {
                          parent.innerHTML = `<span class="text-sm font-bold text-blue-700">${client.name.slice(0, 3).toUpperCase()}</span>`;
                        }
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Main Logo Grid — 4 cols desktop / 3 tablet / 2 mobile */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 mb-10">
          {corporateClients.map((client) => (
            <LogoCard key={`grid-${client.name}`} client={client} />
          ))}
        </div>

        {/* Commitment note */}
        <div className="flex items-start gap-3 bg-blue-50 border border-blue-100 rounded-xl px-5 py-4 mb-6 max-w-4xl mx-auto">
          <ShieldCheck className="text-blue-600 mt-0.5 flex-shrink-0" size={20} />
          <p className="text-sm text-blue-800 leading-relaxed">
            We are committed to providing reliable, accurate and timely health services to our corporate partners across industries.
          </p>
        </div>

        {/* Services grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 mt-8">
          {services.map((svc) => (
            <div
              key={`svc-${svc.label}`}
              className="flex flex-col items-center text-center bg-blue-50 rounded-xl p-4 border border-blue-100"
            >
              <svc.icon className="text-blue-600 mb-2" size={24} />
              <span className="text-xs font-semibold text-blue-800 whitespace-pre-line leading-tight">
                {svc.label}
              </span>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <Link
            href="/contact"
            className="inline-flex items-center gap-2 btn-primary px-8 py-3 text-sm font-semibold"
          >
            <Phone size={16} />
            Enquire for Corporate Health Checkups
          </Link>
        </div>
      </div>
    </section>
  );
}
